
const generateSeed = () => {
  const crypto = window.crypto || window.msCrypto
  const codeList = new Uint32Array(1)
  return crypto.getRandomValues(codeList)
}

const generateCodeString = (length) => {
  const code = Array.apply(null, { length: length })
    .map(() => {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const pattern = /[a-zA-Z0-9]/
      while (length > 0) {
        result += characters.charAt(generateSeed()[0] * length % characters.length)
        if (pattern.test(result)) {
          break
        }
        length--
      }
      return result
    }).join('')
  return code
}

export const generateID = () => `${generateSeed()}-${generateCodeString(9)}`
